.textSection { 
    display: flex;
    flex-wrap: wrap;
    gap: 40px;
    margin-top: 20px;    
}

.scoresSection {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    margin-top: 20px;
}

.scoresSection > div {
    display: flex;
    flex: 1 1 calc(33.333%);
    flex-direction: column;
    min-width: 160px;
}

.buttonContainer {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}
